








































































import {Component, Vue} from 'vue-property-decorator';
import LayerPopup from '@/components/LayerPopup.vue';
import {
	DeleteInstagramTokenRequest,
	GetInstagramConfigurationRequest, GetInstagramPreviewRequest, InstagramMedia
} from 'ncp-api-supporter/dist/types/modules/manage/instagram';
import {ncpPopup} from '@/utils/ncp';

type ImageType = 'landscape' | 'portrait' | 'dummy'

interface InstagramMediaImage extends InstagramMedia {
	imageType: ImageType
}

const getImageType = (url: string): Promise<ImageType> => {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = () => resolve(img.width > img.height ? 'landscape' : 'portrait')
		img.src = url;
	});
}

@Component({
	components: {
		LayerPopup,
	},
})
export default class InstagramIntegrationForm extends Vue {
	private readonly mallNo: string = this.$route.params.id;
	
	private showTooltip = false;
	private instagramContents: InstagramMediaImage[] = []
	private instagramAccessToken = ''
	private errorMsg = '';
	
	get hasIntegration() {
		return Boolean(this.instagramAccessToken)
	}
	
	created() {
		this.fetchInstagramConfig();
	}
	
	
	private async fetchInstagramPreview() {
		const request: GetInstagramPreviewRequest = {
			params: {
				mallNo: Number(this.mallNo),
				accessToken: this.instagramAccessToken,
			},
		}
		
		try {
			const {data} = await this.$api.getInstagramPreview(request)
			return data.data.slice(0, 5)
		} catch (err) {
			console.error(err)
			if (err.data.code === 'IS0002') {
				alert('인스타그램 연동 정보가 유효하지 않습니다. 다시 연동해주세요.')
				this.errorMsg = '';
				this.instagramDeIntegration(true, true)
			}
		}
	}
	
	private async fetchInstagramConfig() {
		const request: GetInstagramConfigurationRequest = {
			params: {
				mallNo: Number(this.mallNo),
			},
		};
		
		const {data} = await this.$api.getInstagramConfiguration(request);
		this.instagramAccessToken = data?.instagramAccessToken ?? '';
		const instagramExpiredYmdt = data.instagramExpiredYmdt?.replace(' ', 'T');
		const expireDateTime = new Date(instagramExpiredYmdt).getTime();
		const isExpired = Date.now() > expireDateTime;
		if (isExpired || data.autoExpired) {
			this.errorMsg = '인스타그램 연동에 실패하였습니다. 다시 연동해주세요.'
		}
		if (isExpired) this.instagramDeIntegration(true, true)
		if (this.hasIntegration) {
			const rawContents = await this.fetchInstagramPreview();
			this.setInstagramContents(rawContents)
		} else {
			this.instagramContents = []
		}
	}
	
	private async instagramIntegration() {
		const {data} = await this.$api.getInstagramLoginUrl();
		const url = data.replace('%7Bdomain%7D', location.host)
		
		ncpPopup(url, '_blank', 800, 900);
	}
	
	private async instagramDeIntegration(silent = false, autoExpired = false) {
		const request: DeleteInstagramTokenRequest = {
			params: {
				mallNo: Number(this.mallNo),
				autoExpired
			}
		}
		const {status} = await this.$api.deleteInstagramToken(request)
		if (status === 204 && !silent) alert('인스타그램 연동이 해제되었습니다.')
		this.fetchInstagramConfig()
	}
	
	private async setInstagramContents(rawContents: InstagramMedia[]) {
		const dummyImages: InstagramMediaImage[] = Array.from(Array(5), () => ({
			mediaType: '',
			thumbnailUrl: require('@/assets/img/dummy-insta-image@2x.png'),
			permalink: '',
			mediaUrl: require('@/assets/img/dummy-insta-image@2x.png'),
			imageType: 'dummy'
		}))
		const instagramContents: InstagramMediaImage[] = await Promise.all(rawContents.map((async (data) => ({
			...data,
			imageType: await getImageType(data.thumbnailUrl || data.mediaUrl || '')
		}))))
		this.instagramContents = instagramContents.concat(dummyImages).slice(0, 5)
	}
	
	get isEmptyContent() {
		return Boolean(this.instagramAccessToken) && this.instagramContents?.[0]?.imageType === 'dummy';
	}
}
